module.exports = __webpack_public_path__ + "static/media/small-play.8ad22c26.svg";